import { constantsTypes } from '../reduxConstants'

export const setGrandTotalamount = (value) => {
  localStorage.setItem('grandTotalData', JSON.stringify(value))
  return {
    type: constantsTypes.GRAND_TOTAL,
    value: value,
  }
}